export default "/images/billing-icon-a.svg?f1a8439198ac5330bc7928add1036717";